import './fiu-pre'; // add all script inside the polyfill file

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import './scss/main.css';
import App from './app';
import * as serviceWorker from './serviceWorker';

ReactDOM.render((
  <BrowserRouter>
    <App/>
  </BrowserRouter>
), document.getElementById('root'));

serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js